/**
 * Bento Cards Carousel: prev/next arrows scroll the mobile track.
 * Scoped to .bento-carousel so other sections are unaffected.
 */
$(function () {
  $('.bento-carousel').each(function () {
    const $section = $(this);
    const track = $section.find('.bento-carousel__track').get(0);
    if (!track) return;

    const step = function () {
      const card = track.querySelector('.bento-carousel__card');
      if (!card) return track.clientWidth;
      const gap =
        parseFloat(window.getComputedStyle(card.parentNode).columnGap) || 0;
      return card.offsetWidth + gap;
    };

    $section.find('.bento-carousel__arrow--prev').on('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    $section.find('.bento-carousel__arrow--next').on('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });
});
